import React from "react";

export default function SvgErrorIcon() {
  return <svg viewBox="0 0 24 24" className="error-icon">
    <path d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm0 3a8.927 8.927 0 0 1 5.2 1.68L4.68 17.198A8.973 8.973 0 0 1 12 3zm0 18a8.928 8.928 0 0 1-5.2-1.68L19.32 6.802A8.973 8.973 0 0 1 12 21z" />
  </svg>;
}